import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import { useDispatch, useSelector } from "react-redux";
import interactionPlugin from "@fullcalendar/interaction";
import { useEffect, useState } from "react";
import "../../../StyleSheet/MainComponent/Calender/Calender.scss";
import { setTheShiftexcelSheetRetrieveAction } from "../../../Redux/Slice";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from "react-router-dom";


const Calender = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [Name, setName] = useState();
  const [udsID, setUdsId] = useState();
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  
  const sheet = state.ClientBranchIDs.ShiftExcelsheetID;

const month = Number(sheet?.month);   // "11" → 11
const year = Number(sheet?.year);     // "2025" → 2025

// 👇 create date like 2025-11-01
const initialDate = new Date(year, month - 1, 1);


const [defaultDate, setDefaultDate] = useState(initialDate);
const [currentDate, setCurrentDate] = useState(defaultDate);


  useEffect(() => {
    ////--Retrieve-----
    const payload = {
      user: state.ClientBranchIDs.ShiftExcelsheetID?.id,
    };
    dispatch(setTheShiftexcelSheetRetrieveAction(payload));
  }, []);

  const [events, setEvents] = useState([]);
  console.log(
    state.ShifteexcelshettRetriev.ShfiexcelRetrieve,
    "ShiftExcelsheetID"
  );
// useEffect(() => {
//   const shiftData = state.ShifteexcelshettRetriev?.ShfiexcelRetrieve;
//   if (!shiftData) return;

//   const NameCap = capitalizeFirstLetter(shiftData?.user_id?.first_name || "");
//   setUdsId(shiftData?.user_id?.user_uid || "");
//   setName(NameCap);
//   const sheet = state.ShifteexcelshettRetriev?.ShfiexcelRetrieve
// const month = Number(sheet?.month);   // "11" → 11
// const year = Number(sheet?.year);     // "2025" → 2025
//   console.log(month, "aspoudaopsd month");

// // 👇 create date like 2025-11-01
// const initialDate = new Date(year, month - 1, 1);

//   if (!month || !year) return;

//   // ✅ FIX: JavaScript months are 0-based
//   const newDefaultDate = new Date(year, month - 1, 1);
//   console.log("✅ showPopup defaultDate", newDefaultDate ,month);
//   setDefaultDate(initialDate);

//   const mappedEvents = [];

//   for (let i = 1; i <= 31; i++) {
//     const dayKey = `day_${i}`;
//     const dayData = shiftData[dayKey];
//     const dayString = i.toString().padStart(2, "0");
//     const monthString = month.toString().padStart(2, "0");

//     const startDate = `${year}-${monthString}-${dayString}T00:00:00+05:30`;
//     const endDate = `${year}-${monthString}-${dayString}T23:59:59+05:30`;

//     if (dayData && typeof dayData === "object") {
//       mappedEvents.push({
//         title: dayData.shift_name,
//         start: new Date(`${year}-${monthString}-${dayString}T${dayData.from_time}+05:30`),
//         end: new Date(`${year}-${monthString}-${dayString}T${dayData.end_time}+05:30`),
//         type: "shift",
//         day: i,
//       });
//     } else if (dayData === "weekoff" || dayData === "no record") {
//       mappedEvents.push({
//         title: dayData === "weekoff" ? "Week Off" : "No Record",
//         start: new Date(startDate),
//         end: new Date(endDate),
//         allDay: true,
//         type: dayData,
//         day: i,
//       });
//     }
//   }

//   setEvents(mappedEvents);
// }, [state.ShifteexcelshettRetriev?.ShfiexcelRetrieve]);
 

const localizer = momentLocalizer(moment);





const eventPropGetter = (event) => {
  let backgroundColor = "";
  let border = "none";
  let color = "#fff";

  switch (event.type) {
    case "shift":
      backgroundColor = "#4caf50"; // ✅ green for shift
      break;
    case "weekoff":
      backgroundColor = "#9e9e9e"; // ⚪ grey for week off
      break;
    case "no record":
      backgroundColor = "#f44336"; // ❌ red for no record
      break;
    default:
      backgroundColor = "#2196f3"; // 🔵 fallback
  }

  return {
    style: {
      backgroundColor,
      border,
      color,
      borderRadius: "6px",
      fontWeight: 600,
      padding: "20px",
      textAlign: "center",
      borderRadius:"13px 13px 0px 0px"
    },
  };
};

  // const workWeekEvents = events.filter((event) => {
  //   const dayOfWeek = moment(event.start).day();
  //   return dayOfWeek >= 1 && dayOfWeek <= 5;
  // });

  const dayStartTime = new Date();
  dayStartTime.setHours(8, 0, 0); // Set to 8:00 AM

  const dayEndTime = new Date();
  dayEndTime.setHours(18, 0, 0); // Set to 6:00 PM

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="row" style={{ padding: "15px", marginRight: "0px" }}>
          <div className="col-6 ">
            <button
              class="btn  Buttons"
              onClick={(e) => {
                navigate("/clientDetails");
              }}
            >
              Back
            </button>
          </div>
        </div>

        <div className="row" style={{ padding: "15px", marginRight: "0px" }}>
          <div className="col-6">
            {Name != undefined ? <h4>{Name}</h4> : null}
          </div>
          <div className="col-6" style={{ textAlign: "end" }}>
            {udsID != undefined ? <h4>{udsID}</h4> : null}
          </div>
        </div>
        <div className="Calender">
          <Calendar
views={["day", "agenda", "work_week", "month"]}
            selectable
            localizer={localizer}
            defaultDate={defaultDate}
            defaultView="month"
            // events={eventsData}
            style={{ height: "100vh" }}
            onClickEvent={(e) => {
              console.log("test", e);
            }}
            events={events}
            // events={workWeekEvents}
            eventPropGetter={eventPropGetter}
          />
        </div>
      </div>
    </>
  );
};

export default Calender;
